import React from 'react'
import './styles.scss'
import Flag from './../../images/flag-emirates.png';

const Footer = (props) => {
    const openFaq = () => {
        document.getElementById('faq').classList.add("active");
    }

    const openPage = (url) => {
        props.history.push( url )
    }
    return (
        <footer>
            <div className="container">
                {/* <span>FAQ</span> */}
                <div className="wrapper">
                    <div className="box">
                        <div className="flag-title">
                            <img src={Flag} alt="" />
                            <p>United Arab Emirates</p>
                        </div>
                    </div>
                    <div className="box">
                        <a href="https://www.grenke.ae/company/grenke-uae/faq-leasing/"  target="_blank">FAQ</a>
                        <a href="https://www.grenke.ae/imprint/"  target="_blank">Legal requirements</a>
                        <a href="https://www.grenke.ae/privacy-policy/"  target="_blank">Privacy Policy</a>
                        <p className="copy">© <a href="https://www.grenke.ae/" target="_blank">grenke</a> { new Date().getFullYear()  }</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;